import { EnglishArabicDTO } from "bnsights-control-library"
import { VariableLookupModel } from "./VariableLookupModel";
export class WFVariableModel
{
      ID:number
      Name :EnglishArabicDTO=new EnglishArabicDTO();
      WorkflowVersionID:number
      DataTypeItemID:number
      VariableTypeItemID:number
      SysName :string
      Value_Identifier:string
      VariableTypeItem:string
      DataTypeItem:string
      IsConstant:boolean
      Value_Text:string
      Value_Number?:number
      Value_Boolean?:number
      Value_Date?:Date
      Value_Int?:number
      Value_Guid?:any
      Value_VariableLookupID?:number
      Single_MultiselectIDs:number[]=[]
      variableLookupDTOs:VariableLookupModel[]=[]
     
}
     